export default __webpack_public_path__ + "static/media/Interior (12).40ffee71.jpg";